import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { PROMO_LANDING_NAME } from 'landings/promo';
import { State } from 'store/types';
import { PromoRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/${PROMO_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);

  return remoteProps => <PromoRemote router={router} store={store} {...remoteProps} />;
});
